import React from 'react';
import './ARFForm.scss'

const ARFConfirmation = () => {
  return <><hr></hr><div className='arfContainer'>
    <header>
      <h1>AGLC - Appointment Request Form</h1>
      <div></div>  
    </header>
    <div className="arfConfirmation">
      <hr></hr>
      <h4>Appointment Request Submitted Successfully</h4>
      <p>Thank you for submitting your Appointment Request Form.
        <br />
        Your request has been received and is being reviewed by our logistics team.
      </p>
      <h4>Next Steps:</h4>
      <ul>
        <li>You will receive an initial email that confirms the process has started.</li>
        <li>A subsequent email will be sent from our team with your confirmed appointment date, time and reference number.</li>
      </ul>
      <p className="disclaimer">
        <b>Important Information:</b>
        <br/>
        <span className="highlighted">The Appointment reference number is required for gate entry onsite.</span>
        <br />
        <b>Note: No driver washroom on site.</b>
      </p>
    </div>
  </div></>;
};

export default ARFConfirmation;
